import React, { useEffect } from "react";
import "./Common_Material_Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAllProductsShape } from "../../../features/products/productsSlice";

const Common_Material_Card = ({ imgScr, title, shape_id }) => {
  const navigate = useNavigate();

  return (
    <>

    <section className="Common_Material_Card  ">
      <div className="img_holder">
        <img src={imgScr} className="inner_img" />
      </div>
      <div className="overlay"></div>
      <div className="title_div">
        <p className="title_text">{title}</p>
        <div
          className="white_box"
          onClick={() =>
            navigate(`/categories?shape_id=${shape_id}&name=${title}`)
          }
        >
          <FontAwesomeIcon icon={faAngleRight} className="inner_icon" />
        </div>
      </div>
    </section>
    </>
  );
};

export default Common_Material_Card;
